export default __webpack_public_path__ + "static/media/points-bar.3418abff.png";